import React from 'react';
import PropTypes from 'prop-types';
import { Layout, Card, Button, Space, Typography, Row, Col } from 'antd';
import { FileTextOutlined, EditOutlined, CheckCircleOutlined } from '@ant-design/icons';
import styles from './ReportTypeSelection.module.css';

const { Title, Text, Paragraph } = Typography;

/**
 * ReportTypeSelection - Step 0 of wizard: Select report type
 *
 * Extracted from ReportWriterV2 to improve modularity
 */
const ReportTypeSelection = ({ onSelectType, onOpenExample }) => {
  return (
    <Layout className={styles.layout}>
      {/* Top Bar */}
      <div className={styles.topBar}>
        <Space className={styles.topBarSpace}>
          <Space>
            <FileTextOutlined className={styles.icon} />
            <Text strong>Create a Report</Text>
          </Space>
        </Space>
      </div>

      {/* Content */}
      <div className={styles.contentArea}>
        <div className={styles.contentContainer}>
          <Title level={2}>Select Report Type</Title>
          <Paragraph type="secondary" className={styles.description}>
            Choose the type of report you want to create.
          </Paragraph>

          <Row gutter={[24, 24]} justify="center">
            <Col xs={24} sm={12} md={10}>
              <Card
                hoverable
                onClick={() => onSelectType('knowledge_gap')}
                className={styles.knowledgeGapCard}
              >
                <Space direction="vertical" size="large" className={styles.knowledgeGapCardSpace}>
                  <EditOutlined className={styles.knowledgeGapIcon} />
                  <div>
                    <Title level={4} className={styles.knowledgeGapTitle}>Knowledge Gap Report</Title>
                    <Text type="secondary">
                      Document questions to answer, learnings, and recommendations
                    </Text>
                  </div>
                  <Button
                    type="link"
                    onClick={(e) => onOpenExample('/examples/kg_example.pdf', e)}
                  >
                    View Example
                  </Button>
                </Space>
              </Card>
            </Col>

            <Col xs={24} sm={12} md={10}>
              <Card
                hoverable
                onClick={() => onSelectType('key_decision')}
                className={styles.keyDecisionCard}
              >
                <Space direction="vertical" size="large" className={styles.keyDecisionCardSpace}>
                  <CheckCircleOutlined className={styles.keyDecisionIcon} />
                  <div>
                    <Title level={4} className={styles.keyDecisionTitle}>Key Decision Report</Title>
                    <Text type="secondary">
                      Capture decisions, purpose, learnings, and recommendations
                    </Text>
                  </div>
                  <Button
                    type="link"
                    onClick={(e) => onOpenExample('/examples/kd_example.pdf', e)}
                  >
                    View Example
                  </Button>
                </Space>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </Layout>
  );
};

ReportTypeSelection.propTypes = {
  onSelectType: PropTypes.func.isRequired,
  onOpenExample: PropTypes.func.isRequired,
};

export default ReportTypeSelection;
